var map = {
	"./de.json": [
		3634,
		"src_assets_i18n_de_json"
	],
	"./en.json": [
		502,
		"src_assets_i18n_en_json"
	],
	"./es.json": [
		4268,
		"src_assets_i18n_es_json"
	],
	"./fr.json": [
		1463,
		"src_assets_i18n_fr_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6297;
module.exports = webpackAsyncContext;